import { WebService } from "../gerenciamento/webservice.model";
import { Markup } from "../gerenciamento/markup.model";
import { Markdown } from "../gerenciamento/markup.model";
import { Moeda } from "../gerenciamento/moeda.model";
import { Alteracoes } from "../base";
import { STATUSRESERVA } from "./reserva.model";
import { Moment } from "moment";

export class Evento {
    Id: number;
    Nome: string;
    Introducao: string;
    PoliticaCancelamento: string;
    DadosVoucher: string;
    ReferenciaInterna: string;
    ValidadeDe: Date;
    ValidadeAte: Date;
    DataInicio: Date;
    DataFim: Date;
    WebServiceId: number;
    WebService: WebService = new WebService();
    Ativo: boolean;
    EventosInclui: EventoInclui[] = [];
    EventoSubCategorias: EventoSubCategoria[] = [];
    EventoReservas: EventoReserva[] = [];
    Erros: string[] = [];
}
export class EventoInclui {
    Nome: string;
    Descricao: string;
    Id: number;
    EventoId: number;
}
export class EventoSubCategoria {
    Nome: string;
    Descricao: string;
    Id: number;
    EventoId: number;
    Evento: Evento;
    EventoImagens: ImagemEvento[] = [];
    EventoCategoriaIngressos: EventoCategoriaIngresso[] = [];
}
export class EventoCategoriaIngresso {
    Id: number;
    Nome: string;
    Descricao: string;
    VendaDe: Date | Moment;
    VendaAte: Date | Moment;
    DataInicio: Date | Moment;
    DataFim: Date | Moment;
    Ativo: boolean;
    QuantidadeTotal: number;
    Valor: number = 0;
    MarkupFixo: number = 0;
    ComissaoFixa: number = 0;
    MoedaId: number;
    Moeda: Moeda = new Moeda();
    Tarifa: EventoCategoriaIngressoTarifa;
    EventoSubCategoria: EventoSubCategoria;
    EventoSubCategoriaId: number;
}
export class EventoMoeda {
    Id: number;
    CodigoISO: string; // Ex: 'BRL'
    Simbolo: string;   // Ex: 'R$'
    Nome: string;
}
export class EventoCategoriaIngressoTarifa {
    MoedaNet: EventoMoeda;
    ValorNet: number;
    ValorVenda: number;
    MoedaListagem: EventoMoeda;
    ValorListagem: number;
    MoedaFechamento: EventoMoeda;
    ValorFechamento: number;
    Taxa: number;
    Multiplica: boolean;
    ValorIRRF: number;
    ValorIRRFListagem: number;
    ValorIRRFFechamento: number;
    ValorIOF: number;
    ValorIOFListagem: number;
    ValorIOFFechamento: number;
    Markup: Markup;
    Markdown: Markdown;
    ValorNetExtra: number;
    ValorTaxaExtra: number;
    MoedaNetId: number;
    TaxaId?: number;
    MoedaFechamentoId: number;
    MoedaListagemId: number;
    MarkupId?: number;
    MarkdownId?: number;
}
export class ImagemEvento {
    Id: number;
    EventoSubCategoriaId: number;
    EventoSubCategoria: EventoSubCategoria;
    ImagemURL: string;
    Principal: boolean;
}

export class BuscaEventoRS {
    Evento: Evento;
    Erros: string[];
    Sucesso: boolean;
}
export class BuscaEventoRQ {
    EventoID: number;
    AgenciaId: number;
}

export class FiltrosEventos {
    Nome: string;
    // ValidadeDe: Date;
    // ValidadeAte: Date;
}

export class EventoReserva {
    // Identificadores
    Id: number;
    EventoId: number;
    EventoCategoriaIngressoId: number;
    ReservaId: number;
    MarkupId: number;
    MarkdownId?: number;
    TaxaId?: number;
    MoedaNetId: number;
    MoedaListagemId: number;
    MoedaFechamentoId: number;

    // Relacionamentos 
    EventoCategoriaIngresso?: EventoCategoriaIngresso;
    Reserva?: any;
    MoedaNet?: Moeda;
    MoedaListagem?: Moeda;
    MoedaFechamento?: Moeda;
    Markup?: any;
    Markdown?: any;

    // Descrições
    DescricaoEvento: string;
    DescricaoSubCategoriaEvento: string;
    DescricaoIngresso: string;
    Localizador: string;
    URLImagemPath: string;

    // Quantidades e valores
    Quantidade: number;
    ValorNet: number;
    ValorVenda: number;
    ValorListagem: number;
    ValorFechamento: number;
    ValorNetExtra: number;
    ValorTaxaExtra: number;

    // Moeda, taxas e impostos
    Taxa: number;
    Multiplica: boolean;
    ValorIRRF: number;
    ValorIRRFListagem: number;
    ValorIRRFFechamento: number;
    ValorIOF: number;
    ValorIOFListagem: number;
    ValorIOFFechamento: number;

    // Datas
    DataReserva?: Date;
    DataCancelamento?: Date;
    DataPagamento?: Date;
    PrazoCancelamentoWs?: Date;

    // Política e status
    PoliticaCancelamento: string;
    Status: STATUSRESERVA;
    StatusDesc: string;

    // Voucher e cliente
    VoucherKey: string;
    VoucherValidacao: string;
    VoucherLogo: string;
    CodigoCliente: string;

    // Exclusão e controle
    Deletado: boolean;
    DeletadoPor: string;
    DeletadoEm?: Date;
    Alteracoes: Alteracoes;
    JustificativaAlteracao: string;
    Erros: string[] = [];
    constructor(init?: Partial<EventoReserva>) {
        Object.assign(this, init);
    }
}
